import type { ValidationFunction, ValidationRule } from '../types';

export const noDuplicatesFn = <T>(
  currentItems: T[],
  compareFn: (value: string, item: T) => boolean = (value, item) =>
    value === item,
): ValidationFunction<string> => {
  return (value) => {
    return !value || !currentItems.some((item) => compareFn(value, item));
  };
};

export const noDuplicates = <T>(
  currentItems: T[],
  compareFn?: (value: string, item: T) => boolean,
): ValidationRule<string> => {
  return {
    fn: noDuplicatesFn(currentItems, compareFn),
    messageKey: 'noDuplicates',
  };
};
